import {Component} from '@angular/core';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {Observable} from 'rxjs';
import {FaqHelp} from '../../../model/strapi/faq-help/faq-help';


@Component({
    selector: 'app-faq-help',
    templateUrl: './faq-help.component.html',
    styleUrls: ['../../../../styles/standard-elements.scss', '../../../pages/help/help.component.scss'],
    standalone: false
})
export class FAQHelpComponent {

  faqs$: Observable<FaqHelp[]> = this.strapiService.getFaqHelp();

  constructor(private readonly strapiService: StrapiService) {}

}


